export const ALLOW_ACCESS                 = 'ALLOW_ACCESS';
export const CLOSE_BUTTON                 = '[data-voc-pw-close]';
export const CONFIG_NAMESPACE             = 'vocento.__PROVIDER__.paywall';
export const CONTENT_CONTAINER            = '[data-voc-pw-layer]';
export const COOKIE_DOMAIN                = `.${window.__VOONTO__.lookup('vocento.site').tlddomain}`;
export const COOKIE_TRIAL_VIEWED_NAME     = 'trialViewed';
export const COOKIE_TRIAL_VIEWED_VALUE    = 'alreadyViewed';
export const COOKIE_TRIAL_PRESCRIPTION    = 'voc_trial';
export const EVOLOK_SESSION_CHECK_PATH    = '/ev_session_check/';
export const PAYWALL_CONTENT              = 'paywall:content';
export const READY_PROMISE_NS             = 'paywall:ready';
export const SET_EVENT                    = 'vtm:set';

/* NOTE: VocUsers config */
export const ANONIMOUS_USER               = 'anonimo';
export const GIGYA_DATA_READY             = 'vocuser:accountsondataready';
export const GIGYA_PRODUCTS_READY         = 'vocuser:productsonready';
export const GIGYA_READY                  = 'vocuser:ready';
export const REGISTER_USER                = 'registrado';
export const TRIAL_USER                   = 'trial';

/* NOTE: Video-Player config */
export const VIDEO_PLAYER_CONTAINER       = '#voc-video-player-modalcontainer';
export const VIDEO_PLAYER_CONTENT_TO_HIDE = '[data-voc-pw-content-to-hide]';
export const VIDEO_PLAYER_MODAL_CONTAINER = '.modal-content';



// WEBPACK FOOTER //
// ./src/constants.js